import React, { useEffect } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";

import AdminLayout from "../layouts/Admin";
import AuthLayout from "../layouts/Auth";

import Page404 from "../pages/auth/Page404";

import { authRoutes, adminRoutes } from ".";

import Page500 from "../pages/auth/Page500";
import Page401 from "../pages/auth/Page401";
import { setGlobalNavigate } from "../utils/navigation";

const NavigationSetter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);
  return null;
};

const routesGeneration = (entry, index) => (
  <Route
    key={entry?.name?.replaceAll(" ", "-") + "-" + index}
    path={entry.path}
    exact
    element={
      <AdminLayout {...entry}>
        {entry.component ? <entry.component /> : null}
      </AdminLayout>
    }
  />
);

const generateRoutes = (routes, callback) =>
  routes.flatMap((route, index) => {
    let transformedItem;
    if (route.component) {
      transformedItem = callback(route, index);
    }

    return [
      transformedItem,
      ...generateRoutes(route.entries || [], routesGeneration),
    ];
  });
const CustomRoutes = () => {
  return (
    <Router>
      <NavigationSetter />
      <Routes>
        {authRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact
            element={
              <AuthLayout>
                <route.component />
              </AuthLayout>
            }
          />
        ))}
        {generateRoutes(adminRoutes, routesGeneration)}
        <Route path={"/"} element={<Navigate to="/rfq/all" />} />
        <Route
          path={"/error/500"}
          element={
            <AuthLayout>
              <Page500 />
            </AuthLayout>
          }
        />
        <Route
          path={"/error/404"}
          element={
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          }
        />
        <Route
          path={"/error/401"}
          element={
            <AuthLayout>
              <Page401 />
            </AuthLayout>
          }
        />
        <Route
          path={"*"}
          element={
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default CustomRoutes;
